export default {
  getFilterHistory: (state) => {
    return state.filterHistory
  },
  cartCache: (state) => {
    return state.cartCache
  }
}
